export default "__VITE_ASSET__56b4b291__"